export default __webpack_public_path__ + "static/media/ANEXO-I-BENEFICIARIO-BENEFICIARIO-PARTE-RENDIMENTO-NORMAL-SEM-DECLARAÇAO-ESPECIAL.e5b87c44.docx";